module.exports = __webpack_public_path__ + "static/media/icn_link.853344b5.svg";